import { useDispatch } from 'react-redux'
import _ from '@strings'
import { nextState } from '@store/actions/app'
import Text from '@components/Ui/Text'
import Spacer from '@components/Ui/Spacer'
import LocationSelect from '@components/Modules/LocationSelect'
import styles from './Location.scss'

const Location = () => {
  const dispatch = useDispatch()

  const setValid = (valid) => {
    if (valid) {
      dispatch(nextState(true, false))
    } else {
      dispatch(nextState(true, true))
    }
  }

  return (
    <div className={styles.base}>
      <Text type="slab_md" center as="div">
        {_('location.headline')}
      </Text>
      <Spacer vertical scale="1" />
      <LocationSelect setValid={setValid} />
    </div>
  )
}

Location.defaultProps = {}
Location.propTypes = {}

export default Location
